<template>
	<div :style="{fontSize: '0.8em'}">
		<span class="countdown countdown-day">{{day}}</span>天
		<span class="countdown countdown-hr">{{hr}}</span>时
		<span class="countdown countdown-min">{{min}}</span>分
		<span class="countdown countdown-sec">{{sec}}</span>秒
	</div>
</template>
<script>
import api from "@/axios";
import { mapState, mapGetters } from "vuex";
const days = 86400;
const hours = 3600;
const minutes = 60;
function countdown(context, match) {
	const end = Date.parse(new Date(match.sdate));
	const now = Date.parse(new Date());
	var msec = end - now;
	if (msec > 0) {
		setInterval(() => {
			msec -= 1000;
			if (msec > 0) {
				let day = parseInt(msec / 1000 / 60 / 60 / 24);
				let hr = parseInt((msec / 1000 / 60 / 60) % 24);
				let min = parseInt((msec / 1000 / 60) % 60);
				let sec = parseInt((msec / 1000) % 60);
				context.day = day > 9 ? day : "0" + day;
				context.hr = hr > 9 ? hr : "0" + hr;
				context.min = min > 9 ? min : "0" + min;
				context.sec = sec > 9 ? sec : "0" + sec;
			}
		}, 1000);
	}
}
export default {
	name: "countdown",
	data() {
		return {
			day: 0,
			hr: 0,
			min: 0,
			sec: 0
		};
	},
	props: ["size"],
	mounted() {
		countdown(this, this.match);
		this.getEquipment()
	
		
	},
	methods: {
		// 获取设备
		getEquipment(){
			let agent=navigator.userAgent
			if(agent.indexOf('Windows ')==-1){
				$('.countdown').css({'padding':0,'font-size':'3em'})
				console.log('移动端');
			}else{
		
			}
		}
	},
	computed: {
		...mapState(["appweb", "match"])
	}
};
</script>
<style scoped>
.countdown-day,
.countdown-hr,
.countdown-min,
.countdown-sec {
	font-size: 4em;
	/* background-color: rgb(245, 237, 237); */
	padding: 0.1em 0.2em;
	margin: 0px 0.1em;
}
</style>



// WEBPACK FOOTER //
// src/components/xd-countdown.vue